module.exports = __webpack_public_path__ + "img/tally-ho.8f3de912.jpg";